"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-location-arrow-16><path fill-rule=evenodd clip-rule=evenodd d="m12.352 3.647-7.672 3.2 2.87.673c.461.108.822.47.93.931l.674 2.868 3.198-7.672Zm.913-2.547c1.03-.43 2.064.604 1.635 1.635l-4.793 11.494c-.467 1.12-2.094.986-2.37-.195L6.64 9.36 1.965 8.265C.785 7.988.65 6.36 1.769 5.895L13.265 1.1Z"></path></symbol>';
}
